<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section
        .viewer--control
          .row.align-items-center
            .col.align__center-md
              button(:disabled="page === 1", @click="GO_PREV_PAGE") 
                span.icon__left: font-awesome-icon(icon="angle-left")
                | Previous Page
              .viewer--page: strong Page {{ page }} of {{ totalPages }}
              button(:disabled="page === totalPages", @click="GO_NEXT_PAGE") 
                | Next Page
                span.icon__right: font-awesome-icon(icon="angle-right")
            .col-lg-auto.align__right.align__center-md
              .mar_t--10-md
                a.viewer--download(:href="filePath", target="_blank")
                  font-awesome-icon(icon="download")
                  span(style="margin-left: 10px;") Download Guide

        .card
          pdf(ref='pdfGuide', :src="filePath", :page='page', @num-pages='totalPages = $event', @link-clicked='page = $event')


        .viewer--control.pos__bottom
          .row.align-items-center
            .col.align__center-md
              button(:disabled="page === 1", @click="GO_PREV_PAGE") 
                span.icon__left: font-awesome-icon(icon="angle-left")
                | Previous Page
              .viewer--page: strong Page {{ page }} of {{ totalPages }}
              button(:disabled="page === totalPages", @click="GO_NEXT_PAGE") 
                | Next Page
                span.icon__right: font-awesome-icon(icon="angle-right")
            .col-lg-auto.align__right.align__center-md
              .mar_t--10-md
                a.viewer--download(:href="filePath", target="_blank")
                  font-awesome-icon(icon="download")
                  span(style="margin-left: 10px;") Download Guide
</template>



<script>
  import pdf from 'vue-pdf'
  import filesInCMS from '@/lib/filesInCMS';

  export default {
    name: 'withdrawalGuide',

    components: {
      pdf
    },

    data() {
      return {
        filePath: filesInCMS.withdrawal.guide,
        page: 1,
        totalPages: 0,
      }
    },

    methods: {
      GO_NEXT_PAGE() {
        this.page++;
      },
      GO_PREV_PAGE() {
        this.page--;
      },
    },
  }
</script>




<style lang="scss">
  .viewer--page {
    display: inline-block;
    min-width: 120px;
    text-align: center;
  }
  .viewer--control {
    background: $color-primary;
    color: #fff;
    padding: 5px 15px 4px;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    margin: 0 0 15px;

    @include MQ(MD) {
      padding: 5px 15px 15px;
    }

    &.pos__bottom {
      margin: 15px 0 0;
    }

    button {
      padding: 10px;
      background: transparent;
      border: 0;
      line-height: 1;
      color: #fff;
      
      span.icon__left,
      span.icon__right {
        position: relative;
        top: 1px;        
      }
      span.icon__left { margin-right: 8px; }
      span.icon__right { margin-left: 8px; }
    }

    button:focus {
      outline: none;
    }
    button:disabled {
      opacity: 0.5;
    }
  }
  .viewer--download {
    color: #fff;
    background: $color-primary_light;
    padding: 5px 12px;
    border-radius: 4px;

    &:hover,
    &:active {
      background: $color-primary;
      color: #fff;
    }
  }
</style>
